import { Loader } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/sharp-regular-svg-icons";
import { AppealPackage } from "@/__generated__/graphql";

import styles from "../styles/components/sponsor-appeals.module.scss";

type PurchaseAppealPackageProps = {
  loading10Pack: boolean;
  loading30Pack: boolean;
  loading100Pack: boolean;
  onSubmit: (appealPackage: AppealPackage) => Promise<void>;
};

function PurchaseAppealPackages({
  onSubmit,
  loading10Pack,
  loading30Pack,
  loading100Pack,
}: PurchaseAppealPackageProps) {
  return (
    <>
      <div className={styles.plan}>
        <div className={styles.planHeaderVolt}>
          <img
            className={styles.packageLogo}
            src="/images/logo/logo_black.svg"
            alt="Claimable"
          />
          <span className={styles.planCategory}>{"Pay-as-you-go"}</span>
          <span className={styles.planType}>{"10-Pack"}</span>
          <span className={styles.whoPays}>{"Free appeals for patients"}</span>
        </div>
        <div className={styles.priceSection}>
          <span className={styles.costDesc}>{"Your cost"}</span>
          <span className={styles.pricePerAppeal}>{"$47"}</span>
          <span className={styles.perAppealText}>{"PER APPEAL SENT"}</span>
          <button
            type="button"
            onClick={() => onSubmit(AppealPackage.TenPack)}
            className={
              loading10Pack || loading30Pack || loading100Pack
                ? styles.planButton
                : styles.planButtonVolt
            }
            disabled={loading10Pack || loading30Pack || loading100Pack}
          >
            {loading10Pack ? (
              <Loader color="black" />
            ) : (
              <div>{"Buy 10-Pack"}</div>
            )}
          </button>
        </div>
        <div className={styles.planDescription}>
          <span className={styles.howItWorks}>{"How it works:"}</span>
          <div className={styles.points}>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Save 5% per appeal"}</span>
            </div>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Patients pay nothing"}</span>
            </div>
          </div>
        </div>
        <br />
        <div className={styles.totalCostSection}>
          <div className={styles.footerText}>
            <span className={styles.totalCostPrice}>{"$470"}</span>
            <span className={styles.totalCostText}>{"TOTAL COST"}</span>
          </div>
        </div>
      </div>
      <div className={styles.plan}>
        <div className={styles.planHeaderVolt}>
          <img
            className={styles.packageLogo}
            src="/images/logo/logo_black.svg"
            alt="Claimable"
          />
          <span className={styles.planCategory}>{"Pay-as-you-go"}</span>
          <span className={styles.planType}>{"30-Pack"}</span>
          <span className={styles.whoPays}>{"Free appeals for patients"}</span>
        </div>
        <div className={styles.priceSection}>
          <span className={styles.costDesc}>{"Your cost"}</span>
          <span className={styles.pricePerAppeal}>{"$45"}</span>
          <span className={styles.perAppealText}>{"PER APPEAL SENT"}</span>
          <button
            type="button"
            onClick={() => onSubmit(AppealPackage.ThirtyPack)}
            className={
              loading10Pack || loading30Pack || loading100Pack
                ? styles.planButton
                : styles.planButtonVolt
            }
            disabled={loading10Pack || loading30Pack || loading100Pack}
          >
            {loading30Pack ? (
              <Loader color="black" />
            ) : (
              <div>{"Buy 30-Pack"}</div>
            )}
          </button>
        </div>
        <div className={styles.planDescription}>
          <span className={styles.howItWorks}>{"How it works:"}</span>
          <div className={styles.points}>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Save 10% per appeal"}</span>
            </div>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Patients pay nothing"}</span>
            </div>
          </div>
        </div>
        <br />
        <div className={styles.totalCostSection}>
          <div className={styles.footerText}>
            <span className={styles.totalCostPrice}>{"$1350"}</span>
            <span className={styles.totalCostText}>{"TOTAL COST"}</span>
          </div>
        </div>
      </div>
      <div className={styles.plan}>
        <div className={styles.planHeaderVolt}>
          <img
            className={styles.packageLogo}
            src="/images/logo/logo_black.svg"
            alt="Claimable"
          />
          <span className={styles.planCategory}>{"Pay-as-you-go"}</span>
          <span className={styles.planType}>{"100-Pack"}</span>
          <span className={styles.whoPays}>{"Free appeals for patients"}</span>
        </div>
        <div className={styles.priceSection}>
          <span className={styles.costDesc}>{"Your cost"}</span>
          <span className={styles.pricePerAppeal}>{"$42"}</span>
          <span className={styles.perAppealText}>{"PER APPEAL SENT"}</span>
          <button
            type="button"
            onClick={() => onSubmit(AppealPackage.OneHundredPack)}
            className={
              loading10Pack || loading30Pack || loading100Pack
                ? styles.planButton
                : styles.planButtonVolt
            }
            disabled={loading10Pack || loading30Pack || loading100Pack}
          >
            {loading100Pack ? (
              <Loader color="black" />
            ) : (
              <div>{"Buy 100-Pack"}</div>
            )}
          </button>
        </div>
        <div className={styles.planDescription}>
          <span className={styles.howItWorks}>{"How it works:"}</span>
          <div className={styles.points}>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Save 15% per appeal"}</span>
            </div>
            <div className={styles.singlePoint}>
              <FontAwesomeIcon icon={faCheck} className={styles.greenCheck} />
              <span className={styles.pointText}>{"Patients pay nothing"}</span>
            </div>
          </div>
        </div>
        <br />
        <div className={styles.totalCostSection}>
          <div className={styles.footerText}>
            <span className={styles.totalCostPrice}>{"$4250"}</span>
            <span className={styles.totalCostText}>{"TOTAL COST"}</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default PurchaseAppealPackages;
